module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/f0482648c8d06761c10c6bc63912b4b2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_select.svg
// module id = 7YQw
// module chunks = 0